<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <div class="col-3">
        <BranchStatsPanel />
      </div>
      <!-- end col -->
      <div class="col-9">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">All Branches</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <all-branch-table />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
/**
 * All Branches Component
 */


import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";
import AllBranchTable from "../../components/Kleyton/Tables/Branch/AllBranchTable";

export default {
  page: {
    title: "All Branches",
    meta: [{ name: "All Branches", content: window.__env.app.description }]
  },
  components: {
    AllBranchTable,
    Layout,
    PageHeader
  },
  data() {
    return {
      createBankFormBody: {
        source: "web"
      },
      title: "Branches",

      items: [
        {
          text: "Branch",
          href: "/"
        },
        {
          text: "Branches",
          active: true
        }
      ]
    };
  }
};
</script>
